import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Message, useToaster } from "rsuite";
import { ClipLoader } from "react-spinners";
import CustomNavbar from "../../components/navbar/Navbar";
import CustomFooter from "../../components/footer/Footer";
import { useChangeAppointmentState } from "../../_store/ChangeAppointment";
import { useHelper } from "../../context/Helper";

const BookingSuccess = () => {
  const { t } = useTranslation("register");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const toaster = useToaster();
  const { getMessage } = useHelper();
  const generateQrCode = useChangeAppointmentState((s) => s.generateQrCode);
  const [qrUrl, setQrUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const caseId = searchParams.get("caseId") || "";
  const ref = searchParams.get("ref") || "";

  useEffect(() => {
    if (!caseId) {
      navigate(ref ? `/?ref=${ref}` : "/");
      return;
    }
    let cancelled = false;
    let createdUrl: string | null = null;

    generateQrCode(caseId).then((result) => {
      if (cancelled) return;
      if (result.blob) {
        createdUrl = URL.createObjectURL(result.blob);
        setQrUrl(createdUrl);
      } else {
        const msg = result.error ? getMessage(result.error) : "";
        toaster.push(
          <Message showIcon type={"error"} closable>
            <strong>แจ้งเตือน!</strong> {msg}
          </Message>,
          { duration: 5000 }
        );
      }
      setLoading(false);
    });

    return () => {
      cancelled = true;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseId]);

  const handleDownload = () => {
    if (!qrUrl) return;
    const a = document.createElement("a");
    a.href = qrUrl;
    a.download = `qr-case-${caseId || "kth"}.png`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleHome = () => {
    navigate(ref ? `/?ref=${ref}` : "/");
  };

  return (
    <>
      <CustomNavbar />
      <div
        className="container-fluid d-flex flex-column p-0"
        style={{ minHeight: "calc(100vh)", backgroundColor: "#e3e3e3" }}
      >
        <div className="p-3 flex-grow-1">
          <div
            className="row d-flex justify-content-center"
            style={{ marginTop: "100px", marginBottom: "30px" }}
          >
            <div className="col-md-6 mb-4">
              <div className="card mb-3">
                <div className="card-body text-center p-4">
                  <div className="mb-3">
                    <svg
                      width="56"
                      height="56"
                      viewBox="0 0 24 24"
                      fill="#52c41a"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                    </svg>
                  </div>
                  <h5 className="mb-2" style={{ fontWeight: 600 }}>
                    {t("bookingSuccess.title")}
                  </h5>
                  <p className="text-muted mb-4" style={{ fontSize: "14px" }}>
                    {t("bookingSuccess.subtitle")}
                  </p>

                  <div
                    className="d-flex justify-content-center align-items-center mb-3"
                    style={{ minHeight: 200 }}
                  >
                    {loading ? (
                      <ClipLoader color="#000" loading={true} size={60} />
                    ) : qrUrl ? (
                      <img
                        src={qrUrl}
                        alt="QR Code"
                        style={{
                          width: "100%",
                          maxWidth: "360px",
                          height: "auto",
                          display: "block",
                        }}
                      />
                    ) : null}
                  </div>

                  <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                    {t("bookingSuccess.hint")}
                  </p>
                </div>
              </div>

              <Button
                color="green"
                appearance="primary"
                className="w-100 mb-2"
                onClick={handleDownload}
                disabled={!qrUrl || loading}
              >
                {t("bookingSuccess.btnDownload")}
              </Button>
              <Button
                appearance="default"
                className="w-100"
                onClick={handleHome}
              >
                {t("bookingSuccess.btnHome")}
              </Button>
            </div>
          </div>
        </div>
        <CustomFooter />
      </div>
    </>
  );
};

export default BookingSuccess;
